export const getUrlParameter = (name) => {
    const url = document.URL;
    const paramValues = url.slice(url.indexOf("?") + 1).split("&");
  
    for (let i = 0; i < paramValues.length; i += 1) {
      const val = paramValues[i].split("=");
      if (val[0] === name) return val[1];
    }
    return null;
  };